// aws and graphql imports
import { API, graphqlOperation } from "aws-amplify";
// import GraphQLAPI, { GRAPHQL_AUTH_MODE } from "@aws-amplify/api-graphql";
import { getAddress, getProduct } from "../graphql/queries";

export const getProductDetails = async (id) =>{
    const _response = await API.graphql({
        query: getProduct,
        variables: { input: { skillName: id } },
      });
      
      // data definition
     return _response?.["data"]?.getProduct;
} // graphql call

export const getAddressDetailsInfo = async (id) =>{
    const _response = await API.graphql({
        query: getAddress,
        variables: {  id: id  },
      });
      
      // data definition
      return _response?.["data"]?.getAddress;
} // graphql call
